import React, { Component } from "react";
import { withStyles } from '@material-ui/core/styles';
import moment from 'moment';
import { consulta } from '../../global/js/funciones';
import ListarDatos from '../general/ListarDatos';
import { BtnDetalle } from '../general/BotonesAccion';
import DetalleAcompanamientoDocente from './DetalleAcompanamientoDocente';
import TareasTerminadas from '../general/TareasTerminadas';
import emma_w from '../../global/imagenes/emma_w.png';
import { actualizarMensaje } from "../../redux/actions/actGlobal";
import { connect } from "react-redux";

const styles = (theme) => ({});



class Historial extends Component {
  constructor(props) {
    super(props);
    this.state = {
      historial: [],
      cargando: true,
      modalDetalleAcompanamiento: false,
      mostrarModalDetalleAcompanamiento: false,
      proceso: null
    };
  }

  async componentDidMount() {
    this.setState({ cargando: true });
    let historial = await this.getProcesos();
    this.setState({ historial, cargando: false });
  }

  getProcesos = () => {
    return new Promise(resolve => {
      consulta("api/v1.0/acompanamiento_docente/procesos", null, null, (error, estado, resp) => {
        resolve(resp || []);
      });
    });
  }

  cerrarModalDetalle = () => {
    this.setState({
      modalDetalleAcompanamiento: false,
      mostrarModalDetalleAcompanamiento: false,
      proceso: null
    });
  }

  pintarHistorial() {
    let { historial } = this.state;

    const acciones = (data) => {
      const onClickDetalle = proceso => {
        this.setState({ 
          proceso,
          modalDetalleAcompanamiento: true,
          mostrarModalDetalleAcompanamiento: true
        });
      }

      let detalle = <BtnDetalle callback={() => onClickDetalle(data)} color='#01579b' texto='Abrir' />;
      return <div>{detalle}</div>;
    }

    const obtenerColor = codigo => {
      let color = '#ffffff';
      const colores = {
        'acom_docen_Regis': { 'backgroundColor': '#f5f5f5', 'color': '#757575' },
        'acom_docen_Pendie': { 'backgroundColor': '#967300ff', color },
        'acom_docen_Finali': { 'backgroundColor': '#009688', color },
        'Tod_Acomp': { 'backgroundColor': '#0d47a1', color }
      };
      return colores[codigo] || { 'backgroundColor': '#f5f5f5', 'color': '#757575' };
    }

    return (
      <>
        <ListarDatos
          datos={historial}
          titulo='Historial de Acompañamiento Docente'
          id='tbl_historial_acompanamiento'
          opciones={true}
          descargar=''
          filtrar={false}
          refrescar={false}
          actfiltrar={() => {}}
          actRefrescar={() => {}}
          acciones={(data) => acciones(data)}
          buscar={true}
          avatar={({ docente_solicitante: { primer_nombre } }) => primer_nombre.toUpperCase().charAt(0)}
          color_avatar={({ estado_actual }) => obtenerColor(estado_actual.codigo)}
          fila_principal={({ docente_solicitante: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido || ''}`}
          filas={[
            { 'id': 'docente', 'mostrar': ({ docente_solicitante: { primer_nombre, primer_apellido, segundo_apellido } }) => `${primer_nombre} ${primer_apellido} ${segundo_apellido || ''}` },
            { 'id': 'identificacion', 'mostrar': ({ docente_solicitante: { identificacion } }) => identificacion },
            { 'id': 'reporte ID', 'mostrar': ({ id }) => `Reporte AC-${id}` },
            { 'id': 'asignatura', 'mostrar': ({ asignatura }) => asignatura },
            { 'id': 'programa', 'mostrar': ({ programa }) => programa ? programa.nombre : '' },
            { 'id': 'grupo', 'mostrar': ({ nombre_grupo_asignatura }) => nombre_grupo_asignatura },
            { 'id': 'fecha_registro', 'mostrar': ({ fecha_registro }) => moment(fecha_registro).format('YYYY-MM-DD, h:mm a') },
            { 'id': 'estado_actual', 'mostrar': ({ estado_actual }) => estado_actual.nombre }
          ]}
        />
      </>
    );
  }

  render() {
    const { cargando, modalDetalleAcompanamiento, mostrarModalDetalleAcompanamiento, proceso } = this.state;
    const { actualizarMensaje, usuario } = this.props;

    if (cargando) {
      return <TareasTerminadas mensaje='Cargando historial' marginTop='7%' imagen={emma_w} widthImg="7%" cargando={true} />;
    }

    return (
      <>
        {this.pintarHistorial()}
        <DetalleAcompanamientoDocente
          proceso={proceso}
          actualizarMensaje={actualizarMensaje}
          modalDetalleAcompanamiento={modalDetalleAcompanamiento}
          mostrarModalDetalleAcompanamiento={mostrarModalDetalleAcompanamiento}
          cerrarModal={this.cerrarModalDetalle}
          cargar="true"
          administrador={false}
          usuario={usuario}
        />
      </>
    );
  }
}

//CARGO ESTADOS DEL MODULO
const mapStateToProps = (state) => {
  let { usuario } = state.redGlobal;
  return {
    usuario
  };
};

//CARGO FUNCIONES DEL MODULO
const mapDispatchToProps = {
  actualizarMensaje
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(Historial));